import React, { Component } from 'react';
import { oneOf } from 'prop-types';
import cx from 'classnames';
import AOS from 'aos';
import Helmet from 'react-helmet';
import 'aos/dist/aos.css';
import { StaticQuery, graphql } from 'gatsby';
import { setConfig } from 'react-hot-loader';

import { Nav, Footer, Grid, Col, Row, Social } from '../components';

import '../styles/index.scss';

import logo from '../assets/logo/logo.svg';
import logoMobile from '../assets/logo/logo-mobile.svg';

const CLASS_ROOT = 'layout';

class Layout extends Component {
  static propTypes = {
    type: oneOf(['transparent']),
  };

  constructor(props) {
    super(props);
    this.handleTransparentLayout = this.handleTransparentLayout.bind(this);
    this.handleLogoFadeIn = this.handleLogoFadeIn.bind(this);
    this.handlePageWrapSpacing = this.handlePageWrapSpacing.bind(this);
  }

  componentDidMount() {
    AOS.init({
      duration: 800,
    });
    this.handleLogoFadeIn();
    this.handleTransparentLayout();
    this.handlePageWrapSpacing();
    setConfig({ logLevel: 'no-errors-please' });
  }

  handleLogoFadeIn() {
    if (
      document.documentElement.querySelector('#main-banner .banner__logo') !==
      null
    ) {
      document.documentElement
        .querySelector('#main-banner .banner__logo')
        .classList.add('show');
    }
  }

  handleTransparentLayout() {
    const transparentBanner = document.querySelector(
      `.${CLASS_ROOT}--transparent .banner`,
    );
    const transparentHeader = document.querySelector(`.${CLASS_ROOT}`);

    if (transparentBanner) {
      let scrollTop = 0;
      document.addEventListener(
        'scroll',
        () => {
          scrollTop = window.scrollY;
          if (transparentBanner.offsetHeight <= scrollTop) {
            transparentHeader.classList.remove('layout--transparent');
          } else {
            transparentHeader.classList.add('layout--transparent');
          }
        },
        false,
      );
    }
  }

  handlePageWrapSpacing() {
    const pageWrap = document.documentElement.querySelector('#page-wrap');
    if (!pageWrap.firstChild.classList.contains('banner')) {
      pageWrap.style.marginTop = '102px';
    }
  }

  render() {
    const { children, className, type, ...other } = this.props;
    const items = [
      {
        title: 'Home',
        url: '/',
      },
      {
        title: 'Creative Movement Studio',
        url: '/creative-movement-studio',
      },
      {
        title: 'Kurzy',
        url: '/kurzy',
      },
      {
        title: 'Workshopy',
        url: '/workshopy',
      },
      {
        title: 'Rozvrh hodín',
        url: '/rozvrh-hodin',
      },
      {
        title: 'Cenník',
        url: '/cennik',
      },
      {
        title: 'Prenájom',
        url: '/prenajom',
      },
      {
        title: 'Kontakt',
        url: '/kontakt',
      },
    ];
    const classes = cx(
      CLASS_ROOT,
      {
        [`${CLASS_ROOT}--${type}`]: type,
      },
      className,
    );

    return (
      <div className={classes} {...other}>
        <Helmet
          meta={[
            {
              name: 'google-site-verification',
              content: 'P8Z4p-SFqq4iVmWr3g-dadmyCehtrNBA39OoS56g_DM',
            },
          ]}
        >
          <html lang="sk" />
        </Helmet>
        <Nav
          logo={logo.id}
          logoMobile={logoMobile.id}
          menuBtn="hamburger"
          items={items}
        />
        <main id="page-wrap">{children}</main>
        <Footer>
          <Grid>
            <Row>
              <Col xs={12} sm={6}>
                <Social />
                <p className="text-small">
                  Privacy © {new Date().getFullYear()} Adrian Bartalos <br />{' '}
                  Design by{' '}
                  <a
                    href="https://instagram.com/benjamin.stary"
                    className="text-color-brick"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @benjamin.stary
                  </a>
                </p>
              </Col>
              <Col xs={6}>
                <p>Creative Movement Studio</p>
                <ul className="list--unstyled">
                  <li>Bajkalská 12/b</li>
                  <li>811 05 Bratislava</li>
                  <li>Slovenská republika</li>
                </ul>
              </Col>
            </Row>
          </Grid>
        </Footer>
      </div>
    );
  }
}

export default Layout;
